/**
 * Cart API Bridge for Horizon theme
 *
 * Third-party cart apps (e.g. slidecarthq) bypass Horizon's event system.
 * This script intercepts both fetch AND XMLHttpRequest calls to cart endpoints,
 * then updates the cart badge DOM directly (Section Rendering approach) and
 * dispatches Horizon's 'cart:update' event as fallback.
 */
(function () {
  const CART_ENDPOINTS = /\/cart\/(add|change|update|clear)\.js/;
  const originalFetch = window.fetch;
  const originalXHROpen = XMLHttpRequest.prototype.open;
  const originalXHRSend = XMLHttpRequest.prototype.send;

  function updateCartCount() {
    originalFetch.call(window, '/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var count = cart.item_count || 0;

        document.querySelectorAll('[ref="cartBubbleCount"]').forEach(function (el) {
          el.textContent = count;
        });
        document.querySelectorAll('[ref="cartBubble"]').forEach(function (el) {
          if (count === 0) {
            el.setAttribute('hidden', '');
          } else {
            el.removeAttribute('hidden');
          }
        });

        document.dispatchEvent(
          new CustomEvent('cart:update', {
            bubbles: true,
            detail: {
              resource: cart,
              sourceId: 'sf-cart-bridge',
              data: {
                source: 'sf-cart-bridge',
                itemCount: count,
              },
            },
          })
        );
      })
      .catch(function () { /* silent */ });
  }

  /* ---- Intercept fetch ---- */
  window.fetch = function () {
    var args = arguments;
    var url = typeof args[0] === 'string' ? args[0] : (args[0] && args[0].url) || '';

    if (!CART_ENDPOINTS.test(url)) {
      return originalFetch.apply(this, args);
    }

    return originalFetch.apply(this, args).then(function (response) {
      if (response.ok) setTimeout(updateCartCount, 200);
      return response;
    });
  };

  XMLHttpRequest.prototype.open = function (method, url) {
    this._sfCartUrl = url;
    return originalXHROpen.apply(this, arguments);
  };

  XMLHttpRequest.prototype.send = function () {
    if (this._sfCartUrl && CART_ENDPOINTS.test(this._sfCartUrl)) {
      this.addEventListener('load', function () {
        if (this.status >= 200 && this.status < 300) {
          setTimeout(updateCartCount, 200);
        }
      });
    }
    return originalXHRSend.apply(this, arguments);
  };
})();
